import { WSRequest } from '@cloudio-saas/datasource-types';
import { atom } from '@cloudio-saas/statex';

export const recordMessagesAtom = atom({
  path: ['transient', 'recordMessages'],
  defaultValue: '',
});

export const recordUIMessagesAtom = atom({
  path: ['transient', 'recordUIMessages'],
  defaultValue: '',
});

export const statusIndicatorMessageAtom = atom({
  path: ['transient', 'testStatusIndicatorMessage'],
  defaultValue: '',
});

export const recordUIMessagesWithWaitAtom = atom({
  path: ['transient', 'recordUIMessagesWithWait'],
  defaultValue: true,
});

export const recordedMessagesAtom = atom<{ req: WSRequest; appUid: string }[]>({
  path: ['transient', 'recordedMessages'],
  defaultValue: [],
});

export const recordedUIMessagesAtom = atom<string[]>({
  path: ['transient', 'recordedUIMessages'],
  defaultValue: [],
});

export const lastMessageAtom = atom<{ req: WSRequest; appUid: string } | null>({
  path: ['transient', 'lastMessage'],
  defaultValue: null,
  onChange: ({ get, set, value }) => {
    const recording = get(recordMessagesAtom);
    if (
      value &&
      recording === value.appUid &&
      ![
        'DropAtom',
        'Enter',
        'Exit',
        'Heartbeat',
        'LogEnter',
        'LogExit',
        'Touch',
      ].includes(value.req.type)
    ) {
      set(recordedMessagesAtom, [...get(recordedMessagesAtom), value]);
    }
  },
});

export const testRunningAtom = atom({
  path: ['transient', 'testRunning'],
  defaultValue: false,
});

export const testRunningMessageAtom = atom({
  path: ['transient', 'testRunningMsg'],
  defaultValue: '',
});
